<template>
  <div>
    <heading :helpInfo="sidebarCard">{{ $t("sidebar.medkitlogs") }}</heading>
    <dateFolderTable
      :rows="rows"
      :loading="loading"
      :nameLabel="$t('folders.year')"
      @open="openYear"
    />
  </div>
</template>

<script>
import dateFolderTable from "../../components/_utils/dateFolderTable.vue";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";

export default {
  name: "medkitlogYears",
  components: { dateFolderTable },
  data: () => ({ counts: {}, loading: false }),
  async created() {
    this.loading = true;
    try {
      this.counts =
        (await this.$store.dispatch("getMedkitlogYearCounts")) || {};
    } finally {
      this.loading = false;
    }
  },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "en") return sidebarTextEN.default.medkitlog;
      return sidebarTextDE.default.medkitlog;
    },
    rows() {
      const present = Object.keys(this.counts)
        .map(Number)
        .filter((n) => !Number.isNaN(n));
      const currentYear = new Date().getFullYear();
      const min = Math.min(currentYear, ...present);
      const max = Math.max(currentYear, ...present);
      const rows = [];
      for (let y = max; y >= min; y--) {
        rows.push({
          key: String(y),
          label: String(y),
          total: (this.counts[String(y)] || {}).total || 0,
        });
      }
      return rows;
    },
  },
  methods: {
    openYear(row) {
      this.$router.push({
        name: "medkitlogMonths",
        params: { year: row.key },
      });
    },
  },
};
</script>
